import { useState, type FormEvent } from "react";
import { api, type User } from "../api";

export default function Login({ onLoggedIn }: { onLoggedIn: (u: User) => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const { user } = await api.login(email, password);
      onLoggedIn(user);
    } catch (e: any) {
      setErr(e.message ?? "Login failed");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="grid min-h-screen place-items-center px-4">
      <form
        onSubmit={submit}
        className="w-full max-w-sm space-y-4 rounded-lg border bg-white p-8 shadow-sm"
      >
        <div>
          <h1 className="text-xl font-semibold">PDF Factory</h1>
          <p className="text-sm text-neutral-500">Sign in to continue.</p>
        </div>
        <label className="block text-sm">
          <span className="text-neutral-700">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2 text-sm focus:border-neutral-900 focus:outline-none"
            autoFocus
          />
        </label>
        <label className="block text-sm">
          <span className="text-neutral-700">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mt-1 w-full rounded border px-3 py-2 text-sm focus:border-neutral-900 focus:outline-none"
          />
        </label>
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button
          disabled={busy}
          className="w-full rounded bg-neutral-900 py-2 text-sm font-medium text-white hover:bg-neutral-800 disabled:opacity-50"
        >
          {busy ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </div>
  );
}
